export default __webpack_public_path__ + "static/media/BATD_Euro.dea87b5c.png";